import { Component, OnDestroy, Input, TemplateRef, ContentChild } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';


@Component({
    selector: 'btn-cell-renderer-delete-clipboard',
    template: `
		<em>
			<div class="info-btn">
				<i *ngIf="enableDelete" title="Delete" class="fas fa-trash-alt custom-icon"  (click)="btnClickedHandler('delete')"></i>
				<i *ngIf="enableClipboard" title="Logs" class="fas fa-clipboard-list custom-icon" (click)="btnClickedHandler('clipboard')"></i>
			</div>
		</em>

		`,
	styles: [`
        .info-btn{
            display: flex;
            gap: 0.8rem;
            color: #fff;
            cursor: pointer;
        }

		::ng-deep .custom-icon {
			/* background: linear-gradient(#000, rgb(49, 49, 49)); */
			border: 1px solid #676A6E;
			padding: 4px 4px 4px 4px;
			/* color: #fff; */
			cursor: pointer;
			background: transparent linear-gradient(180deg, #ffffff 0%, #e9f0f3 100%) 0% 0% no-repeat padding-box;
			opacity: 1;
			font: normal normal bold 10px;
			color: #676a6e;
		}
    `],
    standalone: false
})
export class BtnCellRendererDeleteClipboard implements ICellRendererAngularComp, OnDestroy {



	refresh(params: ICellRendererParams): boolean {
		throw new Error(`Error while refreshing renderer component. INFO-${params}`);
	}

	private params: any;
	pageName;
	enableClipboard: boolean = false;
	enableDelete: boolean = false;

	agInit(params: any): void {
		this.params = params;
		this.pageName = this.params.colDef.field;

		//history
		if (this.params.colDef.field == "history_deleteclipboard") {  // NOSONAR
			this.enableClipboard = true;
			this.enableDelete = true;
		}

	}

	btnClickedHandler(action) {

		if (action == 'delete') {  // NOSONAR
			this.params.context.componentParent.deleteTemplateRow(this.params.data, this.pageName);
		}
		else if (action == 'clipboard') {  // NOSONAR
			this.params.context.componentParent.clipboardTemplateRow(this.params.data, this.pageName);
		}
	}

	ngOnDestroy() {
		// do nothing 
	}
}
